import { Component } from 'react';

class S3 extends Component {

  static downloadPresignedUrlObject(url){

    let promise = new Promise((resolve, reject) => {
      var request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = "text";
      request.onload = function () {
        if (request.readyState == 4 || request.status == 200) {            
            resolve(request.responseText);
        } else { 
            reject(new Error(request.statusText));
        }
      };
      request.onerror = function (e) {
        console.error(request.statusText);
      };
      request.send(null);
    })

    return new Promise(function(resolve, reject) {
      promise.then((response) => {
        try{
          return JSON.parse(response)
        }
        catch (error){
          return null
        }
      }).then((result) => {
        resolve(result)
      }).catch((error) => {
        reject(error);
      });
    })
  }
}

export default S3;


// WEBPACK FOOTER //
// ./src/js/S3.js